import builder from '../builder';
import AccountingCoins from '../../streamline-icons/light/accounting-coins.svg';

export default builder('IconAccountingCoinsLight', AccountingCoins);
